export const casualPageConfig = {
  "title": "Active",
  "titleCN": "活跃",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/engagement/active",
  "defaultTab": "activeUsers",
  "tabList": [
    {
      "id": "activeUsers",
      "tabName": "Active Users",
      "tabNameCN": "基础分析",
      "isHaveNotification": true,
      "notificationPath": "/engagement/active/activeUsers",
      "path": "/engagement/active/activeUsers",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200701",
        "pageName": "iaa-active engaementActiveActiveUsers",
        "extInfo": "iaa-active engaementActiveActiveUsers",
        "pagePath": "/engagement/active/activeUsers"
      },
      "filters": [
        {
          "name": "ActiveUsersFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/engagement/active/activeUsers",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "ActiveUsersTrendCo",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/engagement/active/metrics"
                    }
                  },
                  "children": [
                    {
                      "name": "ActiveUsersTrendCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/engagement/active/dim_metrics_trend",
                          "dataKey": "activeUsersByUaNetwork",
                          "extraParams": {
                            "metric": "active_users",
                            "accumulation": {
                              "custom_accumulation": [
                                {
                                  "key": "ua_network",
                                  "is_accumulation": true
                                }
                              ]
                            }
                          },
                          "formatData": "function(data) {\n                                                        var list = data.list;\n                                                        var rest = Object.assign({}, data);\n                                                        delete rest.list;\n                                                        return Object.assign({}, rest, {\n                                                            dau_channels: list || []\n                                                        });\n                                                    }"
                        }
                      },
                      "children": [
                        {
                          "name": "CommonRow",
                          "className": "margin-b-10 margin-t-10",
                          "type": "layout",
                          "style": {},
                          "props": {},
                          "children": [
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "engagement/active",
                                  "componentKey": "DauActiveUsersCardCo"
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "engagement/active",
                                  "componentKey": "PcuAcuActiveUsersCardCo"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "name": "CommonRow",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {},
                          "children": [
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "engagement/active",
                                  "componentKey": "DauBreakDownActiveUsersCardCo"
                                }
                              ]
                            },
                            {
                              "name": "CommonCol",
                              "className": "",
                              "type": "layout",
                              "style": {},
                              "props": {
                                "w": 12
                              },
                              "children": [
                                {
                                  "name": "MetricComponent",
                                  "path": "engagement/active",
                                  "componentKey": "DauChannelsActiveUsersCardCo"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "RankListTabCo",
                      "className": "",
                      "style": {},
                      "type": "view",
                      "data": {
                        "regionDataType": "country",
                        "tabOrder": [
                          "country",
                          "region",
                          "campaign"
                        ],
                        "tabMsg": {
                          "country": {
                            "aliasNameEn": "Countries",
                            "aliasNameCn": "国家"
                          },
                          "region": {
                            "aliasNameEn": "Regions",
                            "aliasNameCn": "区域"
                          },
                          "campaign": {
                            "aliasNameEn": "Campaign",
                            "aliasNameCn": "Campaign"
                          }
                        },
                        "optionsInit": [
                          {
                            "value": "campaign",
                            "textEn": "Campaign",
                            "textCn": "Campaign"
                          }
                        ]
                      },
                      "children": [
                        {
                          "name": "MetricComponent",
                          "path": "engagement/active",
                          "componentKey": "ActiveUserCommonRankListCo"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "onlineAnalysis",
      "tabName": "Playtime Analysis",
      "tabNameCN": "在线分析",
      "isHaveNotification": true,
      "notificationPath": "/engagement/active/onlineAnalysis",
      "path": "/engagement/active/onlineAnalysis",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200702",
        "pageName": "iaa-active engaementActiveOnlineAnalysis",
        "extInfo": "iaa-active engaementActiveOnlineAnalysis",
        "pagePath": "/engagement/active/onlineAnalysis"
      },
      "filters": [
        {
          "name": "ActiveOnlineFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/engagement/active/onlineAnalysis",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "MetricComponent",
                  "path": "engagement/active",
                  "componentKey": "AveragePlaytimeTrendCo",
                  "height": 416
                },
                {
                  "name": "MetricComponent",
                  "path": "engagement/active",
                  "componentKey": "OverallTableCo",
                  "height": 726,
                  "data": {
                    "tableMetric": [
                      "dwm",
                      "total_online_time",
                      "average_online_time",
                      "login_count",
                      "average_online_time_per_login"
                    ]
                  }
                },
                {
                  "name": "MetricComponent",
                  "path": "engagement/active",
                  "componentKey": "AveragePlaytimeDistributionCo",
                  "height": 416
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "activeDegree",
      "tabName": "Active Degree",
      "tabNameCN": "活跃度分析",
      "isHaveNotification": true,
      "notificationPath": "/engagement/active/activeDegree",
      "path": "/engagement/active/activeDegree",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200703",
        "pageName": "iaa-active engaementActiveActiveDegree",
        "extInfo": "iaa-active engaementActiveActiveDegree",
        "pagePath": "/engagement/active/activeDegree"
      },
      "filters": [
        {
          "name": "ActiveDegreeFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/engagement/active/activeDegree",
          "componentList": [
            {
              "name": "ActiveDegreeContentCo",
              "className": "",
              "type": "view",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "WeeklyActiveUsersServiceCo",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "data": {
                    "timeTypeIsShowCom": [
                      "week"
                    ]
                  },
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/engagement/active/degree_weekly"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "margin-b-10 margin-t-10",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "engagement/active",
                              "componentKey": "WeekLoginActiveUsersCo",
                              "height": 430
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "engagement/active",
                              "componentKey": "WeekActiveUsersDaysCo",
                              "height": 430
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "WeeklyActiveUsersServiceCo",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "data": {
                    "timeTypeIsShowCom": [
                      "week"
                    ]
                  },
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/engagement/active/degree_blweekly"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "engagement/active",
                              "componentKey": "WeekActiveUsersActivityCo",
                              "height": 430
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "engagement/active",
                              "componentKey": "BiWeekActiveUsersDaysCo",
                              "height": 430
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "WeeklyActiveUsersServiceCo",
                  "className": "",
                  "type": "view",
                  "style": {
                    "marginTop": "20px"
                  },
                  "data": {
                    "timeTypeIsShowCom": [
                      "month"
                    ]
                  },
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/engagement/active/degree_monthly"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "className": "",
                      "type": "layout",
                      "props": {},
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "engagement/active",
                              "componentKey": "MonthLoginActiveUsersCo",
                              "height": 430
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 12
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "engagement/active",
                              "componentKey": "MonthActiveUsersDaysCo",
                              "height": 430
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};